import React, { useEffect, useState } from 'react';
import { Folder, Copy, Plus } from 'react-feather'; // Assuming you have a 'Plus' icon
import { useRouter } from 'next/router';
import styles from 'styles/Header.module.scss';
import classnames from 'classnames';
import userApi from 'api/userApi';
import { getThemeColor } from 'store/settings';
import { MdEditNote, MdPersonOutline } from 'react-icons/md';
import { useSelector } from 'react-redux';
import { getSelectedCentre } from 'store/master';
import { handleToastError } from 'helpers';
import { getViewMode } from 'store/auth';
import { USER_ROLES } from 'constants/constants';

const Card = ({ icon, count, label, onClick, additionalContent }) => {
  const viewMode = useSelector(getViewMode);
  return (
    <div
      className={classnames(
        'col-md-3 pl-0',
        styles['grid-margin'],
        styles['stretch-card'],
      )}
    >
      <div
        className={classnames(
          'card-stats',
          'rounded-right',
          styles['card-stats'],
          styles['mb-4'],
          styles['mb-xl-0'],
          styles['card'],
          styles['cardshade1'],
        )}
        style={{ cursor: 'pointer' }}
      >
        <div className={classnames('left', styles['left'])}>{icon}</div>
        <div className="card-body statistics-card-size" onClick={onClick}>
          <h2
            className={classnames(
              'dashboard-counts',
              styles['dashboard-counts'],
            )}
          >
            {count ? count : 0}
          </h2>
          <span
            className={classnames('card-label-font', styles['card-label-font'])}
          >
            {label}
          </span>
        </div>
        {additionalContent && viewMode !== USER_ROLES.CENTRE_ADMIN && (
          <div className={styles['additional-content-container']}>
            {additionalContent.text && (
              <div
                className={classnames(styles['add-button'], 'btn')}
                onClick={additionalContent.onClick}
              >
                <Plus className={styles['plus-icon']} />
                Add
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

const DataCounts = () => {
  const router = useRouter();
  const selectedCentre = useSelector(getSelectedCentre);
  const [instructorsummary, setInstructorsummary] = useState([]);
  const themeStatus = useSelector(getThemeColor);

  const getInstructorSummary = async () => {
    try {
      const response = await userApi.getInstructorSummary(
        selectedCentre?._id ? { courseCentre: selectedCentre?._id } : null,
      );
      setInstructorsummary(response);
    } catch (error) {
      handleToastError(error);
    }
  };

  useEffect(() => {
    getInstructorSummary();
  }, [selectedCentre]);

  const navigateTo = (path) => router.push(path);

  return (
    <div className={classnames('container-xl', styles['mt-1'])}>
      <div className={classnames('row', styles['equal-height-row'])}>
        {[
          {
            icon: (
              <Folder
                className={classnames('left-icon', styles['left-icon'])}
              />
            ),
            count: instructorsummary.courses,
            label: 'Courses',
            onClick: () => navigateTo('/course/courseGrid'),
            additionalContent: {
              text: true,
              onClick: () => navigateTo('/course/create'),
            },
          },
          {
            icon: (
              <MdEditNote
                className={classnames('left-icon', styles['left-icon'])}
              />
            ),
            count: instructorsummary.intakes,
            label: 'Classes',
            onClick: () => navigateTo('/intakes/intake-grid'),
            additionalContent: {
              text: true,
              onClick: () => navigateTo('/intakes/create'),
            },
          },
          {
            icon: (
              <MdPersonOutline
                className={classnames('left-icon', styles['left-icon'])}
              />
            ),
            count: instructorsummary.users,
            label: 'Users Enrolled',
          },
          {
            icon: (
              <Copy
                className={classnames(
                  'left-icon',
                  'material-icons-outlined',
                  styles['left-icon'],
                )}
              />
            ),
            count: instructorsummary.units,
            label: 'Units',
          },
        ].map((card, index) => (
          <Card key={index} {...card} />
        ))}
      </div>
    </div>
  );
};

export default DataCounts;
